import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { ProApproverDetailModel } from "src/app/model/ProApproverDetailModel";
import { ProApproverService } from "src/app/services/pro-approver.service";
// import { ViewPdfComponent } from "../view-pdf/view-pdf.component";
// import { ProRejectCaseComponent } from "./reject-case/pro-reject-case.component";
import {
  InAppBrowser,
  InAppBrowserEvent,
  InAppBrowserOptions,
} from "@awesome-cordova-plugins/in-app-browser/ngx";
import { ESignService } from "src/app/services/esign-service.service";
import { ApplicantDetailListModel } from "src/app/model/ApplicantDetailListModel";
import { ViewPdfComponent } from "src/app/secure/view-pdf/view-pdf.component";
// import { ProApproveCaseComponent } from "./approve-case/pro-approve-case.component";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { RejectCaseComponent } from "../reject-case-modal/reject-case.component";
import { ViewImageComponent } from "../../view-image-modal/view-image.component";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { DomSanitizer } from "@angular/platform-browser";
import { ViewProfileDocumentComponent } from "src/app/audit-trail/profile-details/view-profile-document/view-profile-document.component";

@Component({
  selector: "marriage-status",
  templateUrl: "./marriage-status.component.html",
  styleUrls: ["./marriage-status.component.scss"],
})
export class MarriageStatusComponent implements OnInit {
  isLoading: boolean = false;
  proApproverDetail: ProApproverDetailModel;
  submitDisabled: boolean;
  applicationNo: number;
  spouseName: string;
  newMaritalStatus: string;
  fileNameAaadhar: string;
  fileNameMarriageCertificate: string;
  fileNamePan: string;
  fileNamePanWithExtension: string;
  fileNameAaadharWithExtension: string;
  fileNameMarriageCertificateWithExtension: string;
  verificationStatus: string;
  approverDetail: ApplicantDetailListModel;
  progressSpinnerDialog: any = null;
  @Input() key: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private proApproverService: ProApproverService,
    private iab: InAppBrowser,
    private esignService: ESignService,
    private modalCtrl: ModalController,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.submitDisabled = false;
    this.route.params.subscribe((params: Params) => {
      this.applicationNo = +params["applicationNo"];
      this.proApproverService
        .fetchApplicantMarriageStatusDetailBykey(this.key)
        .subscribe((data) => {
          this.approverDetail = data;
          this.spouseName = data.spouseName;
          this.newMaritalStatus = data.newMaritalStatus;
          this.fileNameAaadhar = data.fileNameAaadhar;
          this.fileNameMarriageCertificate = data.fileNameMarriageCertificate;
          this.fileNamePan = data.fileNamePan;
          this.fileNamePanWithExtension = data.fileNamePanWithExtension;
          this.fileNameAaadharWithExtension = data.fileNameAaadharWithExtension;
          this.fileNameMarriageCertificateWithExtension =
            data.fileNameMarriageCertificateWithExtension;
          this.isLoading = false;
        });
    });
  }

  async reject() {
    const modal = await this.modalCtrl.create({
      component: RejectCaseComponent,
      componentProps: {
        // pan: this.proApproverDetail.pan,
        // applicantName: this.proApproverDetail.applicantName,
      },
    });
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role === "reject") {
      this.onSubmit("REJECTED", data);
    }
  }

  async approve() {
    this.onSubmit("APPROVED", null);
  }

  onSubmit(statusType: string, rejectReason?: string) {
    this.isLoading = true;
    this.submitDisabled = true;
    this.proApproverService
      .submitVerificationDetailForApplicant(this.key, statusType, rejectReason)
      .subscribe(
        (data) => {
          if (data.status === "SUCCESS") {
            if (statusType === "APPROVED") {
              this.isLoading = false;
              this.proApproverService.successToast(
                "Applicant with Application Number - " +
                  this.applicationNo +
                  " has been Approved."
              );
              this.updateDetailsInApplicantTable();
              this.router.navigate([
                "/secure",
                "applicant-editing-approver-list",
              ]);
            } else {
              this.isLoading = false;
              this.proApproverService.successToast(
                "Applicant with Application Number -" +
                  this.applicationNo +
                  " has been Rejected."
              );
              this.router.navigate([
                "/secure",
                "applicant-editing-approver-list",
              ]);
            }
          } else {
            this.isLoading = false;
            this._snackBar.open(data.errorMessage, "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "warning-toast",
              duration: 3 * 1000,
            });
            this.submitDisabled = false;
          }
        },
        (error) => {
          this.submitDisabled = false;
          this.isLoading = false;
          this._snackBar.open(error.errorMessage, "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
          });
        }
      );
  }

  updateDetailsInApplicantTable() {
    this.isLoading = true;
    this.submitDisabled = true;
    this.proApproverService
      .updateMarriageDetailsInApplicantTable(
        this.applicationNo,
        this.newMaritalStatus,
        this.spouseName,
        this.fileNameAaadhar,
        this.fileNameMarriageCertificate,
        this.fileNamePan,
        this.fileNamePanWithExtension,
        this.fileNameAaadharWithExtension,
        this.fileNameMarriageCertificateWithExtension
      )
      .subscribe(
        (data) => {
          if (data.status === "SUCCESS") {
            this.proApproverService.successToast(
              "Applicant Table Updated with Application Number " +
                this.applicationNo
            );
          } else {
            this.isLoading = false;
            this._snackBar.open(data.errorMessage, "Close", {
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: "warning-toast",
              duration: 3 * 1000,
            });
            this.submitDisabled = false;
          }
        },
        (error) => {
          this.submitDisabled = false;
          this.isLoading = false;
          this._snackBar.open(error.errorMessage, "Close", {
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: "warning-toast",
            duration: 3 * 1000,
          });
        }
      );
  }

  // async viewEsignCertificate() {
  //   this.proApproverService
  //     .fetchEsignCertificate(this.certJournalistKey)
  //     .subscribe(async (data) => {
  //       if (data.status === "SUCCESS") {
  //         this.downloadFile(
  //           data.data,
  //           this.proApproverDetail?.pan +
  //             "_JR_CERTIFICATE_" +
  //             new Date().getTime() +
  //             ".pdf"
  //         );
  //       } else {
  //         this.proApproverService.errorToast(data.errorMessage);
  //       }
  //     });
  // }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `data:application/pdf;base64,${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }

  async viewFile(fileType, file) {
    console.log("File ka data", file);

    const progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
    const imageUrls = await Promise.all(
      file.split(",").map(async (imageData) => {
        if (imageData) {
          console.log("imageData", imageData);

          const response = await this.proApproverService
            .downloadFile(imageData)
            .toPromise();
          if (response != null && !response.error) {
            const binary = new Uint8Array(response);
            const url =
              "data:image/jpg;base64," +
              btoa(String.fromCharCode.apply(null, binary));
            return this.domSanitizer.bypassSecurityTrustUrl(url);
          }
        }
        return null;
      })
    );
    const [imageUrl, imageBackUrl] = imageUrls;
    progressSpinnerDialog.close();
    const dialogRef = this.dialog.open(ViewImageComponent, {
      disableClose: false,
      width: "600px",
      data: [imageUrl, imageBackUrl],
    });
    dialogRef.afterOpened().subscribe(() => {
      setTimeout(() => {}, 100);
    });
  }

  // async viewFile(fileType, file) {
  //   const progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
  //     disableClose: true,
  //     panelClass: "progressSpinner",
  //   });

  //   const imageUrls = await Promise.all(
  //     file.split(",").map(async (imageData) => {
  //       if (imageData) {
  //         const response = await this.proApproverService
  //           .downloadFile(imageData)
  //           .toPromise();
  //         if (response != null && !response.error) {
  //           const binary = new Uint8Array(response);
  //           const url =
  //             "data:image/jpg;base64," +
  //             btoa(String.fromCharCode.apply(null, binary));
  //           return this.domSanitizer.bypassSecurityTrustUrl(url);
  //         }
  //       }
  //       return null;
  //     })
  //   );

  //   const [imageUrl, imageBackUrl] = imageUrls;

  //   // Close the progress dialog before opening the modal
  //   progressSpinnerDialog.close();

  //   const dialogRef = this.dialog.open(ViewImageComponent, {
  //     disableClose: false,
  //     width: "600px",
  //     data: [imageUrl, imageBackUrl],
  //   });

  //   // Listen for the afterOpened event to ensure the modal is fully ready
  //   dialogRef.afterOpened().subscribe(() => {
  //     // You can optionally add a delay here if needed
  //     // setTimeout(() => {
  //     //   dialogRef.updateSize(); // Update the modal size if needed
  //     // }, 100);
  //   });
  // }
}
